// src/api/apiConfig.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 60000,
  timeoutErrorMessage: "Request timed out. Please try again later.",
});

// ---- Helpers kept local (no Redux here)
const getDeviceId = () => {
  let id = localStorage.getItem("deviceId");
  if (!id) {
    id = `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("deviceId", id);
  }
  return id;
};

const clearAuthLocal = () => {
  try {
    localStorage.clear();
  } catch {
    // ignore
  }
};

// ---- Request: attach auth + device
axiosInstance.interceptors.request.use((config) => {
  const authToken = localStorage.getItem("authToken");
  const systemName = localStorage.getItem("systemName");
  if (authToken) config.headers["X-Auth-Token"] = authToken;
  if (systemName) config.headers["X-System-Name"] = systemName;
  config.headers["X-Device-Id"] = getDeviceId();
  return config;
});

// ---- Response: central errors that do NOT need Redux
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Timeouts
    if (error?.code === "ECONNABORTED") {
      return Promise.reject(
        new Error("The request timed out. Please try again later."),
      );
    }

    const status = error?.response?.status;
    const data = error?.response?.data;

    // 1) Session invalid/expired: go to Login immediately (no refresh needed)
    if (status === 401) {
      setTimeout(() => {
        clearAuthLocal();
      }, 2000);
      // if you have a navigator bridge, use it; otherwise fall back to hard replace
      return Promise.reject(error);
    }

    // 2) Exit flow locked -> send to final page
    if (data?.errorCode === "EXIT_LOCKED") {
      try {
        if (data.resumeToken)
          localStorage.setItem("EXIT_RESUME_TOKEN", data.resumeToken);
        if (data.tier) localStorage.setItem("EXIT_TIER", data.tier);
      } catch {}

      return Promise.reject(error);
    }

    // default: bubble up
    return Promise.reject(error);
  },
);
